// Product data
export const products = [
  {
    id: 1,
    name: "Dish Washing Liquid",
    tagline: "Sparkling Clean Dishes",
    description: "Powerful plant-based formula that cuts through grease while being gentle on hands.",
    image: "https://customer-assets.emergentagent.com/job_3cbc8c81-fb19-4dcb-8665-22a7d3f951d4/artifacts/y9i6r581_IMG_5398.jpeg",
    features: ["Plant-Powered Formula", "Soft on hands", "Fresh, Natural scent"],
    size: "500ml",
    featured: true
  },
  {
    id: 2,
    name: "Multi-Surface Cleaner",
    tagline: "One Spray, All Clean",
    description: "Versatile disinfectant cleaner for all surfaces. Removes grease and grime instantly.",
    image: "https://customer-assets.emergentagent.com/job_3cbc8c81-fb19-4dcb-8665-22a7d3f951d4/artifacts/ha590ih3_IMG_5798.jpeg",
    features: ["Plant-Powered Formula", "Removes grease & grime", "Fresh, Natural scent"],
    size: "500ml",
    featured: true
  },
  {
    id: 3,
    name: "Bathroom Cleaner",
    tagline: "Fresh & Hygienic",
    description: "Powerful bathroom cleaning solution with plant-based ingredients for a sparkling bathroom.",
    image: "https://customer-assets.emergentagent.com/job_3cbc8c81-fb19-4dcb-8665-22a7d3f951d4/artifacts/2ge4elnl_IMG_5965.jpeg",
    features: ["Plant-Powered Formula", "Deep cleaning", "Fresh, Natural scent"],
    size: "500ml",
    featured: false
  },
  {
    id: 4,
    name: "Floor Cleaner",
    tagline: "10X Cleaning Power",
    description: "Advanced floor cleaning formula that's safe for kids and pets. Goodness of plants.",
    image: "https://customer-assets.emergentagent.com/job_3cbc8c81-fb19-4dcb-8665-22a7d3f951d4/artifacts/gqsjzxxa_IMG_5685.jpeg",
    features: ["Plant-Powered Formula", "Kid & Pet safe", "Fresh, Natural scent"],
    size: "1L",
    alsoAvailable: "5L also available",
    featured: false
  }
];
